import { useQuery } from "@tanstack/react-query";
import { getStatus } from "services/apiUpload";

const useGetStatus = (orderId, onSettled) => {
  const { isPending: isLoading, isSuccess, error, data, refetch } = useQuery({
    queryKey: ["orderStatus", orderId],
    queryFn: ({ queryKey }) => {
      const actualOrderId = queryKey[1];
      // console.log("Extracted orderId:", actualOrderId);
      return getStatus(actualOrderId);
    },
    enabled: !!orderId,
    retry: false,
    onSettled: (data, error) => {
      console.log("Query has settled!");
      if (onSettled) {
        onSettled(data, error);
      }
    }
  });

  return { isLoading, error, data, refetch, isSuccess };
};


export default useGetStatus;
